import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Login from '../views/Login.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import ResetPassword from '../views/ResetPassword.vue'
import Users from '../views/Management/Users.vue'
import Sources from '../views/Management/Sources.vue'
import SourceProxies from '../views/Management/SourceProxies.vue'
import Proxy from '../views/Management/Proxy.vue'
import ProxyDomains from '../views/Management/ProxyDomains.vue'
import ProxyCountryUse from '../views/Management/ProxyCountryUse.vue'
import Operators from '../views/Management/Operators.vue'
import Partners from '../views/Management/Partners.vue'
import Tables from '../views/Management/Tables.vue'
import Files from '../views/Management/Files.vue'
import Currencies from '../views/Management/Currencies.vue'
import SoftSwissCurrencies from '../views/Management/SoftSwissCurrencies'
import AltSsBrandTokens from '../views/Management/AltSsBrandTokens.vue'
import AggrConfigs from '../views/Management/AggrConfigs.vue'
import EngineConfigs from '../views/Management/EngineConfigs.vue'
import EngineOperators from '../views/Management/EngineOperators.vue'
import InfoPlayers from '../views/Management/InfoPlayers.vue'
import Limits from '../views/Management/Limits.vue'
import Dealers from '../views/Management/Dealers.vue'
import Welcome from '../views/Welcome.vue'
import Main from '../modules/main/main.vue'
import Aggregator from '../views/Management/Aggregator.vue'
import Localization from '../views/Management/Localization.vue'
import TableLimits from '../views/Management/TableLimits.vue'
import WazdanFreespins from '../views/Management/WazdanFreespins.vue'
import TomHornFreespins from '../views/Management/TomHornFreespins.vue'
import SoftSwissFreespins from '../views/Management/BGamingFreespins.vue'
import AltenteFreespins from '../views/Management/AltenteFreespins.vue'
import AdminChat from '../views/Management/Chat/AdminChat.vue'
import ShowChat from '../views/Management/Chat/ShowChat.vue'
import ChatHistory from '../views/Management/Chat/ChatHistory.vue'
import ProviderGames from '../views/Management/ProviderGames.vue'
import GameTypes from '../views/Management/GameTypes.vue'
import LimitsTemplates from '../views/Management/LimitsTemplates.vue'
import SidebetNames from '../views/Management/SidebetNames.vue'
import OppositeSidebets from '../views/Management/OppositeSidebets.vue'
import SideBets from '../views/Management/SideBets.vue'
import * as Roles from '../definitions/Roles'
import ProviderNames from '../views/Management/ProviderNames.vue'
import TableOperations from '../views/Management/TableOperations.vue'
import VideoMonitoring from '../views/Management/VideoMonitoring.vue'
import PartnerSettings from '../views/Management/PartnerSettings.vue'
import CountryBlocks from '../views/Management/CountryBlocks.vue'
import Logs from '../views/Management/Logs.vue'
import UploadFreeChips from '../views/Management/UploadFreeChips.vue'
import { isFeatureEnabled } from '../utils/features'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Main,
    children: [
      {
        path: '/welcome',
        name: 'Welcome',
        component: Welcome,
        meta: { requiresAuth: true }
      },
      {
        path: '',
        name: 'Welcome Root',
        component: Welcome,
        meta: { requiresAuth: true }
      },
      {
        path: '/partners',
        name: 'Partners',
        component: Partners,
        meta: { requiresAuth: true }
      },
      {
        path: '/operators',
        name: 'Operators',
        component: Operators,
        meta: { requiresAuth: true }
      },
      {
        path: '/config',
        name: 'Configs',
        component: EngineConfigs,
        meta: { requiresAuth: true }
      },
      {
        path: '/aggr-config',
        name: 'Aggr Configs',
        component: AggrConfigs,
        meta: { requiresAuth: true }
      },
      {
        path: '/engine-operators',
        name: 'Back Operators',
        component: EngineOperators,
        meta: { requiresAuth: true }
      },
      {
        path: '/info-players',
        name: 'Info players',
        component: InfoPlayers,
        meta: { requiresAuth: true }
      },
      {
        path: '/proxies',
        name: 'Proxy',
        component: Proxy,
        meta: { requiresAuth: true }
      },
      {
        path: '/proxy-domains',
        name: 'Proxy Domains',
        component: ProxyDomains,
        meta: { requiresAuth: true }
      },
      {
        path: '/proxy-country-use',
        name: 'Proxy Country Use',
        component: ProxyCountryUse,
        meta: { requiresAuth: true }
      },
      {
        path: '/sources',
        name: 'Sources',
        component: Sources,
        meta: { requiresAuth: true }
      },
      {
        path: '/source-proxies',
        name: 'Source Proxies',
        component: SourceProxies,
        meta: { requiresAuth: true }
      },
      {
        path: '/users',
        name: 'Users',
        component: Users,
        meta: { requiresAuth: true }
      },
      {
        path: '/tables',
        name: 'Tables',
        component: Tables,
        meta: { requiresAuth: true }
      },
      {
        path: '/table-operations',
        name: 'Table Operations',
        component: TableOperations,
        meta: { requiresAuth: true }
      },
      {
        path: '/limits',
        name: 'Limits',
        component: Limits,
        meta: { requiresAuth: true }
      },
      {
        path: '/limits-templates',
        name: 'Limits Templates',
        component: LimitsTemplates,
        meta: { requiresAuth: true }
      },
      {
        path: '/side-bets',
        name: 'Side Bets',
        component: SideBets,
        meta: { requiresAuth: true }
      },
      {
        path: '/sidebet-names',
        name: 'Side Bet Names',
        component: SidebetNames,
        meta: { requiresAuth: true }
      },
      {
        path: '/opposite-sidebets',
        name: 'Opposite Bets',
        component: OppositeSidebets,
        meta: { requiresAuth: true }
      },
      {
        path: '/currencies',
        name: 'Currencies',
        component: Currencies,
        meta: { requiresAuth: true }
      },
      {
        path: '/softswiss-currencies',
        name: 'SoftSwiss Currencies',
        component: SoftSwissCurrencies,
        meta: { requiresAuth: true }
      },
      {
        path: '/alt-ss-brand-tokens',
        name: 'Alt SS Brand Tokens',
        component: AltSsBrandTokens,
        meta: { requiresAuth: true }
      },
      {
        path: '/aggregator',
        name: 'Aggregator',
        component: Aggregator,
        meta: { requiresAuth: true }
      },
      {
        path: '/dealers',
        name: 'Dealers',
        component: Dealers,
        meta: { requiresAuth: true }
      },
      {
        path: '/localization',
        name: 'Localization',
        component: Localization,
        meta: { requiresAuth: true }
      },
      {
        path: '/table-limits',
        name: 'Table Limits',
        component: TableLimits,
        meta: { requiresAuth: true }
      },
      {
        path: '/wazdan-freespins',
        name: 'Wazdan Freespins',
        component: WazdanFreespins,
        meta: { requiresAuth: true }
      },
      {
        path: '/bgaming-freespins',
        name: 'BGaming Freespins',
        component: SoftSwissFreespins,
        meta: { requiresAuth: true }
      },
      {
        path: '/tomhorn-freespins',
        name: 'Tom Horn Freespins',
        component: TomHornFreespins,
        meta: { requiresAuth: true }
      },
      {
        path: '/altente-freespins',
        name: 'Altente Freespins',
        component: AltenteFreespins,
        meta: { requiresAuth: true }
      },
      {
        path: '/provider-games',
        name: 'Provider Games',
        component: ProviderGames,
        meta: { requiresAuth: true }
      },
      {
        path: '/provider-names',
        name: 'Provider Names',
        component: ProviderNames,
        meta: { requiresAuth: true }
      },
      {
        path: '/partners-settings',
        name: 'Partners Settings',
        component: PartnerSettings,
        meta: { requiresAuth: true }
      },
      {
        path: '/game-types',
        name: 'Game Types',
        component: GameTypes,
        meta: { requiresAuth: true }
      },
      {
        path: '/country-blocks',
        name: 'Country Blocks',
        component: CountryBlocks,
        meta: { requiresAuth: true }
      },
      {
        path: '/files',
        name: 'Files',
        component: Files,
        meta: { requiresAuth: false }
      },
      {
        path: '/admin-chat',
        name: 'Admin Chat',
        component: AdminChat,
        meta: { requiresAuth: true }
      },
      {
        path: '/admin-chat/:table_id',
        name: 'Show Chat',
        component: ShowChat,
        meta: { requiresAuth: true }
      },
      {
        path: '/chat-history',
        name: 'Chat History',
        component: ChatHistory,
        meta: { requiresAuth: true }
      },
      {
        path: '/video-monitoring',
        name: 'Video Monitoring',
        component: VideoMonitoring,
        meta: { requiresAuth: true }
      },
      {
        path: '/logs',
        name: 'Logs',
        component: Logs,
        meta: { requiresAuth: true }
      },
      // Условный роут для Upload Free Chips (показывается только при включенной фиче)
      ...(isFeatureEnabled('UPLOAD_FREE_CHIPS')
        ? [
            {
              path: '/upload-free-chips',
              name: 'Upload Free Chips',
              component: UploadFreeChips,
              meta: { requiresAuth: true }
            }
          ]
        : [])
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: ResetPassword
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      await store.dispatch('loadCurrentUser')
      let currentUser = store.getters.currentUser
      if (currentUser.type === Roles.ADMIN) {
        next()
        return
      }

      if (currentUser.allowedPages === null) {
        next()
        return
      }
      if (to.path === '' || to.path === '/welcome') {
        next()
        return
      }

      const baseRoute = to.path
        .split('/')
        .slice(0, -1)
        .join('/')
      if (
        currentUser.allowedPages.some(page => {
          const regex = new RegExp(page)
          return regex.test(baseRoute) || regex.test(to.path)
        })
      ) {
        next()
        return
      } else {
        next('/welcome')
        return
      }
    }
    if (to.fullPath !== '/') {
      next({ name: 'Login', query: { redirect: to.fullPath } })
    } else {
      next('/login')
    }
  } else {
    next()
  }
})

// Экспортируем функцию проверки фич для использования в компонентах
export { isFeatureEnabled }

export default router
